import React, {useEffect, useState} from "react";
import {Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row} from "reactstrap";
import {useSelector} from "react-redux";


// components
import {getStateByPath} from "../../redux/selectors";


// services
import {activityService} from "../../jwt/_services/core/activityService";
import ActivitiesByUdn from "../../views/promotions/activity/components/ActivitiesByUdn";





const PromotionActivityComponent = path => {
    const componentState = useSelector(state => getStateByPath(state, path));
    const { app, domainObject} = componentState?.data;



    const [loadingActivityDetails, setLoadingActivityDetails] = useState(false)


    const [activity, setActivity] = useState(domainObject?.activity?.id || null)
    const [activityDetails, setActivityDetails] = useState()
    const [activityPrices, setActivityPrices] = useState([])
    const [normalAmount, setNormalAmount] = useState(0.0)
    const [amountWithDiscount, setAmountWithDiscount] = useState(0.0)


    const [udn, setUdn] = useState(domainObject?.activity?.udn?.id || null)


    const [discountPercentage, setDiscountPercentage] = useState(domainObject?.porcentaje || 0)
    const [discountMount, setDiscountMount] = useState(domainObject?.monto || 0)






    // Para gestionar el cambio de actividad
    useEffect(() => {
        if(!activity) return

        loadActivityDetails()
    }, [activity]);



    // Para calcular el descuento cuando cambian los precios de la actividad
    useEffect(() => {
        if(!activity) return;

        calculateDiscount()
    }, [activityPrices]);





    // Cargar los detalles de la actividad seleccionada
    const loadActivityDetails = () => {
        setLoadingActivityDetails(true)


        activityService.getItem(activity?.id, app?.fbDataBase?.id)
        .then(response => {

            setActivityDetails(response)
            getActivityPrice(response)

        } )
        .catch(error => console.error("Error loading activities:", error))
        .finally(() => setLoadingActivityDetails(false) );
    }
    





    // Filtrar los precios de la actividad para obtener solo los que están activos
    const getActivityPrice = activityDetails => {
        if (!activityDetails || !activityDetails?.prices || activityDetails?.prices?.length === 0)
            return 
        
        const activeCurrencies = ['MXN', 'USD']; // Lista de monedas activas
        

        const prices = activityDetails.prices.filter( price => activeCurrencies.includes(price.currency) );
        
        setActivityPrices(prices);
    }

    // Calcular el descuento basado en la actividad seleccionada
    const calculateDiscount = () => {
        const selectedCurrency =  "MXN"; // Cambia esto según la moneda que desees usar

        const activityPrice = activityPrices.find(price => price.currency === selectedCurrency);
        const price = activityPrice?.normalAmount || 0; // Precio normal de la actividad en la moneda seleccionada

        setNormalAmount(price);
        applyDiscount(discountPercentage, price); // Aplicar el descuento basado en el porcentaje actual
    }

    // Manejar el cambio del porcentaje de descuento
    const onPercentageChange = e => {
        let value = e.target.value

        if (value < 0 )
            value = 0

        if( value > 100 )
            value = 100

        setDiscountPercentage(value);


        applyDiscount(value, normalAmount); // Aplicar el descuento basado en el porcentaje ingresado
    }

    const applyDiscount = (discountPercentage, amount) => {
        const discountToApply = (amount * (discountPercentage / 100)).toFixed(2); // calcular el descuento a aplicar

        setDiscountMount(discountToApply) // Calcular el descuento en monto
        setAmountWithDiscount((amount - discountToApply).toFixed(2)); // Calcular el precio con descuento
    }

    // Manejar el cambio del monto de descuento
    const onMountChange = e => {
        let value = e.target.value;
        const amount = Number(normalAmount);

        if (value < 0 )
            value = 0

        if( value > amount )
            value = amount

        setDiscountMount(value);

        const number_value = Number(value);
        const discountToApply = (number_value / normalAmount) * 100  // Calcular el porcentaje de descuento

        setDiscountPercentage(discountToApply.toFixed(2)) // Actualizar el porcentaje de descuento;
        setAmountWithDiscount(normalAmount - number_value); // Calcular el precio con descuento
    }

    // Asignar los valores seleccionados externamente
    const assignActivityValues = (udn, activity) => {
        setUdn(udn)
        setActivity(activity)
    }


    
    const component  = () => <>
        <Row>
            <Col>
                <FormGroup>
                    <ActivitiesByUdn
                        path={path}
                        setExternalValues = { assignActivityValues }
                    />
                </FormGroup>
            </Col>
        </Row>


        <Row>
            <Col>
                <FormGroup>
                    <Label>{'Porcentaje de Descuento'}</Label>
                    <InputGroup>
                        <Input
                            type="number"
                            name="porcentaje"
                            placeholder={'Porcentaje'}
                            step={"0.01"}
                            min={0}
                            max={100}
                            disabled={ loadingActivityDetails || !activity }
                            value={discountPercentage}
                            onChange={onPercentageChange}
                        />
                        <InputGroupText>%</InputGroupText>
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col>
                Precio de la actividad: <br/><br/>
                {
                    loadingActivityDetails
                        ? <i className="fa fa-spinner fa-spin fa-2x fa-fw"/>
                        : <b>${normalAmount}</b>
                }
            </Col>
        </Row>

        <Row>
            <Col>
                <FormGroup>
                    <Label>{'Monto de Descuento'}</Label>
                    <InputGroup>
                        <InputGroupText>$</InputGroupText>
                        <Input
                            type="number"
                            name="monto"
                            placeholder={'Monto'}
                            step={"0.01"}
                            disabled={ loadingActivityDetails || !activity }
                            value={discountMount}
                            onChange={onMountChange}
                        />
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col>
                Precio después del descuento: <br/><br/>
                {
                    loadingActivityDetails
                        ? <i className="fa fa-spinner fa-spin fa-2x fa-fw"/>
                        : <b>${amountWithDiscount}</b>
                }
            </Col>
        </Row>
    </>

    return  {
        component,
        udn,
        activity:activityDetails,
        normalAmount,
        amountWithDiscount,
        discountMount,
        discountPercentage
    }
 }


 export default PromotionActivityComponent;